module.exports = __webpack_public_path__ + "assets/txplan-blue-icon.370f16739a698dfb13d717a1620daa00.svg";